
import Swiper from 'swiper';
import { Navigation, Autoplay, FreeMode } from 'swiper/modules';
import gsap from "gsap";

// Nav menu mobile rwd

const btnMob = document.querySelector(".mobile-nav-btn");
const navMobActive = document.querySelector(".nav-mobil-on");

btnMob.addEventListener("click", function () {
  btnMob.classList.toggle("active");
  navMobActive.classList.toggle("active-nav-mob");
});


// =================================================================================
//    A     CCC   TTTTT  U   U   SSS        FFFFF  III  L      TTTTT  EEEEE  RRRR
//   A A   C   C    T    U   U  S           F       I   L        T    E      R   R
//  A   A  C        T    U   U   SSS        FFF     I   L        T    EEE    R   R
//  AAAAA  C        T    U   U      S       F       I   L        T    E      RRRR
//  A   A  C   C    T    U   U      S       F       I   L        T    E      R  R
//  A   A   CCC     T     UUU   SSSS        F      III  LLLLL    T    EEEEE  R   R
// =================================================================================
// * * * actus filter

const isListFilter = document.querySelector(".sort-section");
const isfaq = document.querySelector(".sort-faq");

if (isListFilter) {
  var box = $(".actus__card"),
    boxContainer = $(".actus__content__wrapper"),
    section = $(".sort-section"),
    // containerHeight = $('.adjustable-height'),
    boxClassFilter,
    showThese;

  $("button").on("click", function () {
    boxClassFilter = $(this).data("filter");
    showThese = boxContainer.find(".actus__card" + "." + boxClassFilter);
    var sectionHeight = section.height();

    $(".cat-container").find("button.selected").removeClass();
    $(this).toggleClass("selected");

    var tl = new gsap.timeline()
      .to(box, 0.5, { opacity: 0 })
      .set(box, { display: "none" })
      .set(showThese, { display: "flex" })
      .to(showThese, 0.8, { opacity: 1 }, "+=0.1")
      .fromTo(
        section,
        1,
        { height: "sectionHeight" },
        { height: "initial" },
        "-=1"
      );

    if (boxClassFilter == "all") {
      var allTL = new gsap.timeline()
        .set(section, { height: sectionHeight })
        .to(box, 0.5, { opacity: 0 })
        .set(box, { display: "none" })
        .set(box, { display: "flex" })
        .to(box, 0.8, { opacity: 1 }, "+=0.1")
        .fromTo(
          section,
          1,
          { height: "sectionHeight" },
          { height: "initial" },
          "-=1"
        );
    }
  });

} else if (isfaq) {

  var box = $(".tabs"),
    boxContainer = $(".faq__list__wrapper"),
    section = $(".sort-faq"),
    // containerHeight = $('.adjustable-height'),
    boxClassFilter,
    showThese;

  $("button").on("click", function () {
    boxClassFilter = $(this).data("filter");
    showThese = boxContainer.find(".tabs" + "." + boxClassFilter);
    var sectionHeight = section.height();

    $(".faqFilter__track").find("button.selected").removeClass();
    $(this).toggleClass("selected");

    var tl = new gsap.timeline()
      .to(box, 0.5, { opacity: 0 })
      .set(box, { display: "none" })
      .set(showThese, { display: "flex" })
      .to(showThese, 0.8, { opacity: 1 }, "+=0.1")
      .fromTo(
        section,
        1,
        { height: "sectionHeight" },
        { height: "initial" },
        "-=1"
      );

    if (boxClassFilter == "all") {
      var allTL = new gsap.timeline()
        .set(section, { height: sectionHeight })
        .to(box, 0.5, { opacity: 0 })
        .set(box, { display: "none" })
        .set(box, { display: "flex" })
        .to(box, 0.8, { opacity: 1 }, "+=0.1")
        .fromTo(
          section,
          1,
          { height: "sectionHeight" },
          { height: "initial" },
          "-=1"
        );
    }
  });
}

const isRealSingle = document.getElementById('singleSection');
if (isRealSingle) {
  const swiper = new Swiper('.mySwiperGal', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 8,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  document.addEventListener("DOMContentLoaded", function (event) {
    Chocolat(document.querySelectorAll('.chocolat-parent .chocolat-image'))
  })
}